export default [
  // 添加排课
  {
    name: 'course-arrange-add',
    component: () => import(/* webpackChunkName: "courseArrangeAddPopup" */ './course-arrange-add.vue'),
  },
  // 排课详情
  // {
  //   name: 'course-arrange-detail',
  //   component: () => import(/* webpackChunkName: "courseArrangeDetailPopup" */ './course-arrange-detail.vue'),
  // },
  // 取消/恢复排课
  {
    name: 'course-arrange-cancel',
    component: () => import(/* webpackChunkName: "courseArrangeCancelPopup" */ './course-arrange-cancel.vue'),
  },
  // 排课冲突
  {
    name: 'course-arrange-conflict',
    component: () => import(/* webpackChunkName: "courseArrangeConflictPopup" */ './course-arrange-conflict.vue'),
  },
  // 编辑排课
  {
    name: 'course-arrange-edit',
    component: () => import(/* webpackChunkName: "courseArrangeEditPopup" */ './course-arrange-edit.vue'),
  },
];
